module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	"use strict";

	fox.registerWidget('Passrecovery', {

		configure: function(options) {			
			this.registerOptions('', {
				templateOptions: {
					success: true
				}
			});

			this.callParent('configure', arguments);
		},
		
		init: function() {
			this.embedWidget('forgotPassword', 'PasswordRecovery', {
				container: '.guest-form',
				'handleDom.submit': {
					target: '#form-submit',
					event: 'click',
					callback: 'changePassword'
				}
			});

			return this.callParent('init', arguments);
		},

		running: function() {
			this.forgotPassword = this.requireEmbeddedWidget('forgotPassword');
			this.forgotPassword.validateHash(fox.Navigator.get(1) || 'aasd');

			this.handleEvent(this.forgotPassword, 'validateHash', fox.bind(this.answerValidateHash, this));
		},

		addedToDom: function () {
			fox.dom.on('click', fox.dom.selectFirst('#form-submit', this.element), fox.bind(this.changePassword, this));
		},

		changePassword: function() {
			var password = fox.trim(this.dom1('#password').value),
				confirm = fox.trim(this.dom1('#confirm').value),
				isValid = true,
				msg = 'Password is empty.';

				if (fox.isEmpty(password) || fox.isEmpty(password)) {
					isValid = false;
				}

				if (password !== confirm) {
					isValid = false;
					msg = 'The password do not match.';
				}

				if (!isValid) {
					this.toggleError(true, msg);

					return;
				}

				this.toggleError(false, msg);
				this.forgotPassword.changePassword(this.hash, password, confirm);
				this.waitEvent(this.forgotPassword, 'changePassword', fox.bind(this.answerChangePassword, this));
				this.waitEvent(this.forgotPassword.wom1('#change'), ['failure'], fox.bind(this.answerChangePassword, this));
		},

		toggleError: function(state, msg) {
			var msgElement = !!this.getOption('errorContainer') ? this.dom('.error-container') : this.dom1('#info-forgot'),
				fields = ['password', 'confirm'];
			if(fox.isArray(msgElement)){
				fields.forEach(function(name) {
					var	elm = this.dom1('#'.concat(name));
					elm.nextElementSibling.children[0].innerHTML = msg || '';
					fox.dom[state === true ? 'addClass' : 'removeClass']('error', elm.parentNode);
				}.bind(this));
			}else{
				var p = msgElement.parentElement;
				fields.forEach(function(name) {
					var	elm = this.dom1('#'.concat(name));
					
					fox.dom[state === true ? 'addClass' : 'removeClass']('error', elm.parentNode);
				}.bind(this));

				if (state) {
					msgElement.innerText = msg || '';
					p.style.display = '';

					return;
				}
				msgElement.innerText = '';
				p.style.display = 'none';
			}

			
		},

		answerValidateHash: function(answer, alias, w) {
			this.setTemplateOptions('success', answer.success);
			this.setOption('templateOptions.success', answer.success);
			this.render();

			if (answer.success) {
				this.hash = answer.hash;
			}
		},

		answerChangePassword: function(resp) {
			var msg;
			var answer = resp.answer;
			// var infoForgotElm = fox.dom.selectFirst('#info-forgot', this.element),
			// 	passwordElm = fox.dom.selectFirst('#password', this.element),
			// 	confirmElm = fox.dom.selectFirst('#confirm', this.element),
			// 	fieldsElm = fox.dom.selectFirst('.fields', this.element),
			// 	buttonsElm = fox.dom.selectFirst('.buttons', this.element),
			// 	msg = 'Your account password was successfully changed. Please login <a href="/login">here</a>.';

			// infoForgotElm.parentElement.style.display = 'block';
			// infoForgotElm.innerHTML = msg;
			// passwordElm.value = '';
			// confirmElm.value = '';

			// if (answer.status) {
			// 	fieldsElm.style.display = 'none';
			// 	buttonsElm.style.display = 'none';
			// }

			if (resp.success == true) {
				this.toggleError(false);

				['password', 'confirm'].forEach(function(name) {
					var	elm = this.dom1('#'.concat(name));

					elm.value = '';
				}.bind(this));

				this.dom1('.info-text').innerHTML = 'Your account password was successfully changed. Please login <a href="/login">here</a>.';

				fox.dom.selectFirst('.fields', this.element).style.display = 'none';
				fox.dom.selectFirst('.buttons', this.element).style.display = 'none';

				return;
			}

			msg = answer.reason;

			if (answer.code === 111) {
				msg = 'New password cannot match your 3 previous ones';
			}

			this.toggleError(true, msg);
		}

	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/passrecovery.js
// module id = 55
// module chunks = 5